var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RunRequest_1;
import './transientConfig'; // force import for JsonSchema
import './runConfig'; // force import for JsonSchema
import { JSON, JsonConverter, JsonSchema, MapConverter } from '@symon-ai/wisepipe-serialize';
import { RunConfig } from './runConfig';
export var RunTrigger;
(function (RunTrigger) {
    RunTrigger["User"] = "user";
    /** Scheduler: Runs requested by Scheduler Service */
    RunTrigger["Scheduler"] = "scheduler";
    /** Not used for now but seems reasonable to have: SalesPlanning can kick off runs */
    RunTrigger["External"] = "external";
    /** Unknown Run Request Source: for old runs / undefined replacement */
    RunTrigger["Unknown"] = "unknown";
})(RunTrigger || (RunTrigger = {}));
const schema = {
    $id: 'urn:wisepipe-common-computation:RunRequest',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        dataMap: {
            type: 'object',
            additionalProperties: { type: 'string', uid: 9 }
        },
        exportMap: {
            type: 'object',
            additionalProperties: { type: ['string', 'null'], if: { type: 'string' }, then: { uid: 9 } }
        },
        name: { type: 'string', minLength: 1 },
        runConfig: {
            type: 'object',
            additionalProperties: { $ref: 'urn:wisepipe-common-computation:RunConfig' }
        },
        transientConfig: { $ref: 'urn:wisepipe-common-computation:TransientConfig' },
        runTrigger: { type: 'string', enum: Object.values(RunTrigger) },
        scheduleID: { type: 'string', uid: 9 },
        selectedOutputs: { type: 'array', items: { type: 'string', uid: 10 } },
        skippedDSRefreshes: { type: 'array', items: { type: 'string', uid: 9 } },
        nodeToIsExcelExport: {
            type: 'object',
            additionalProperties: { type: 'boolean' }
        }
    },
    required: ['pipeID', 'dataMap'],
    // make sure that transient+exportmap cannot be specified at same time
    not: { required: ['transientConfig', 'exportMap'] }
};
let RunRequest = RunRequest_1 = class RunRequest {
    constructor(pipeID, dataMap, name, runConfig, exportMap, transientConfig, runTrigger, scheduleID, selectedOutputs, skippedDSRefreshes, nodeToIsExcelExport) {
        this.pipeID = pipeID;
        this.dataMap = dataMap;
        if (name !== undefined)
            this.name = name;
        if (runConfig !== undefined)
            this.runConfig = runConfig;
        if (exportMap !== undefined)
            this.exportMap = exportMap;
        if (transientConfig !== undefined)
            this.transientConfig = transientConfig;
        if (runTrigger !== undefined)
            this.runTrigger = runTrigger;
        if (scheduleID !== undefined)
            this.scheduleID = scheduleID;
        if (selectedOutputs !== undefined)
            this.selectedOutputs = selectedOutputs;
        if (skippedDSRefreshes !== undefined)
            this.skippedDSRefreshes = skippedDSRefreshes;
        if (nodeToIsExcelExport !== undefined)
            this.nodeToIsExcelExport = nodeToIsExcelExport;
        JSON.validate(this, RunRequest_1);
    }
};
__decorate([
    JsonConverter(new MapConverter())
], RunRequest.prototype, "dataMap", void 0);
__decorate([
    JsonConverter(new MapConverter())
], RunRequest.prototype, "exportMap", void 0);
__decorate([
    JsonConverter(new MapConverter(RunConfig))
], RunRequest.prototype, "runConfig", void 0);
__decorate([
    JsonConverter(new MapConverter())
], RunRequest.prototype, "nodeToIsExcelExport", void 0);
RunRequest = RunRequest_1 = __decorate([
    JsonSchema(schema)
], RunRequest);
export { RunRequest };
//# sourceMappingURL=runRequest.js.map